import { render } from "./cross2.vue?vue&type=template&id=541c9b6c"
import script from "./cross2.vue?vue&type=script&lang=js"
export * from "./cross2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__